import { render } from "./SlideOver.vue?vue&type=template&id=2b0cf256"
import script from "./SlideOver.vue?vue&type=script&lang=js"
export * from "./SlideOver.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2878166519/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__